import api from "../../console/api";

/** Fetches an authenticated PDF and hands back an object URL (preview iframe, download, print). Rendering has no side effects. */
export async function fetchPdf(body) {
  const r = await api.post("/admin/print/render", body, { responseType: "blob" });
  const name = (/filename="([^"]+)"/.exec(r.headers["content-disposition"] || "") || [])[1] || "heritage-print.pdf";
  return { url: URL.createObjectURL(new Blob([r.data], { type: "application/pdf" })), name };
}

export async function fetchBatchPdf(batchId, doc) {
  const r = await api.get(`/admin/print/batches/${batchId}/${doc}.pdf`, { responseType: "blob" });
  const name = (/filename="([^"]+)"/.exec(r.headers["content-disposition"] || "") || [])[1] || `${doc}.pdf`;
  return { url: URL.createObjectURL(new Blob([r.data], { type: "application/pdf" })), name };
}

export function downloadUrl(url, name) {
  const a = document.createElement("a");
  a.href = url; a.download = name; document.body.appendChild(a); a.click(); a.remove();
}

/** Opens the PDF in a new tab so the browser print dialog shows real page sizes (no browser headers/footers on PDF). */
export function printUrl(url) {
  const w = window.open(url, "_blank", "noopener");
  if (!w) downloadUrl(url, "heritage-print.pdf");
}

/** Deep-link from Packing rows / bulk buttons: /admin/print?doc=invoice&orders=id1,id2 */
export function printCenterLink(doc, ids) {
  return `/admin/print?doc=${encodeURIComponent(doc)}&orders=${encodeURIComponent((ids || []).join(","))}`;
}
